module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("callme_widget_full", [["div",{"class":"title"},[["textNode",{"text":"Verified Call"}]]],["div",{"class":"custom-text","data-fox-alias":"callmeText"},[["p",{},[["textNode",{"text":"Want to hear my sexy voice? If the sign is green, give me a call! If its red, give me your number and I'll let you know once I'm available. "}]]]]]]);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-dynamic-injection!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-template-loader?interpolate!./templates/sitepage/callme/callmeTemplates.tpl
// module id = 71
// module chunks = 4